import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { API_URL } from '../lib/api'

export function useUTM() {
  const location = useLocation()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const utmSource = params.get('utm_source')
    const utmMedium = params.get('utm_medium')
    const utmCampaign = params.get('utm_campaign')
    const utmContent = params.get('utm_content')

    if (utmSource || utmMedium || utmCampaign) {
      if (utmSource) sessionStorage.setItem('utm_source', utmSource)
      if (utmMedium) sessionStorage.setItem('utm_medium', utmMedium)
      if (utmCampaign) sessionStorage.setItem('utm_campaign', utmCampaign)
      if (utmContent) sessionStorage.setItem('utm_content', utmContent)

      fetch(`${API_URL}/api/funnel/utm`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: location.pathname,
          utm_source: utmSource,
          utm_medium: utmMedium,
          utm_campaign: utmCampaign,
          utm_content: utmContent,
          referrer: document.referrer || null,
          visitor_id: getOrCreateVisitorId(),
        }),
      }).catch(() => {})
    }
  }, [location.search, location.pathname])
}

function getOrCreateVisitorId(): string {
  let id = localStorage.getItem('fc_visitor_id')
  if (!id) {
    id = crypto.randomUUID()
    localStorage.setItem('fc_visitor_id', id)
  }
  return id
}

export function getStoredUTM(): Record<string, string> {
  return {
    utm_source: sessionStorage.getItem('utm_source') || '',
    utm_medium: sessionStorage.getItem('utm_medium') || '',
    utm_campaign: sessionStorage.getItem('utm_campaign') || '',
    utm_content: sessionStorage.getItem('utm_content') || '',
  }
}
